import { Button, FormControl, Grid, Input, Menu, MenuItem, Select, Typography, makeStyles } from '@material-ui/core';
import { KeyboardBackspace } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { ErrorToast, formatDate } from '../utils/Utils';
import Theme from '../ui/Theme';
import PXMetrics from './PXMetrics';
import { TabNativeContent } from '../common/Tab';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { showProgress } from '../../redux/actions/DealershipActions';
import { TableWrapper } from './TableWrapper';
import { CustomDatePopup } from './CustomDatePopup';
import { LearningHistory } from './LearningHistory';
import { UserStats } from './UserStats';
import ShareGuidePopup from '../dealership/ShareGuidePopup';
import AssignJourneyPopup from '../dealership/AssignJourneyPopup';
// import PxGraph from './PxGraph';

const useStyles = makeStyles(() => ({
  modal: {
    background: '#F2F4F7',
  },
  btn: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0px 30px',
    height: '10vh',
    cursor: 'pointer',
    background: '#fff',
  },
  dealershipContainer: {
    height: '84vh',
    width: '100%',
    padding: '15px 30px',
  },
  dealerInfo: {
    display: 'flex',
    width: '96%',
  },
  infos: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    width: '85%',
  },
  heading: {
    color: '#121212',
    fontWeight: '700',
    fontSize: '28px',
  },
  smallText: {
    color: '#667085',
    fontSize: '12px',
    fontWeight: '400',
  },
  btnBox: {
    width: '18%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  overview: {
    display: 'flex',
    width: '96%',
    marginTop: '15px',
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '85%',
  },
  title: {
    color: '#10182B',
    fontWeight: '700',
    fontSize: '18px',
  },
  textfield: {
    height: '40px',
    width: '100%',
    padding: '12px 12px 12px 12px',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '21px',
    border: '1px solid gray',
  },
  cards: {
    display: 'flex',
    width: '96%',
    marginTop: '10px',
  },
  table: {
    width: '96%',
    marginTop: '10px',
    height: '53vh',
    background: '#fff',
  },
  filterBtn: {
    display: 'flex',
    gap: '20px',
    padding: '10px',
    width: '97%',
    margin: '0px 10px 10px',
    borderTop: '1px solid #F2F4F7',
    borderBottom: '1px solid #F2F4F7',
  },
  activeFilterBtn: {
    background: '#EBE9FE',
    color: '#622FEE',
    borderRadius: '4px',
    padding: '0px 8px',
    fontSize: '12px',
    height: '40px',
  },
  deactiveFilterBtn: {
    border: '1px solid #667085',
    borderRadius: '4px',
    padding: '0px 8px',
    fontSize: '12px',
    height: '40px',
    color: '#667085',
  },
  shareBtn: {
    width: '150px',
    height: '42px',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    backgroundColor: Theme.palette.primary.main,
    color: Theme.palette.secondary.main,
    cursor: 'pointer',
    marginRight: '10px',
    '&:hover': {
      backgroundColor: Theme.palette.primary.main,
      color: Theme.palette.secondary.main,
    },
  },
}));

const contentStyles = {
  display: 'flex',
  flexDirection: 'column',
  padding: '0px 0px 28px',
  position: 'absolute',
  left: '17vw',
  top: '0',
  width: '83vw',
  height: '100vh',
  background: '#F2F4F7',
  zIndex: '10000',
};

export const IndividualDealership = ({
  dealerId,
  setDealerId,
  PERIOD_ARR,
  appliedFilters,
  setAppliedFilters,
  timePeriod,
  setTimePeriod,
  handleOpenInsightPopup,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const pxDashboardFilters = useSelector((state) => state.pxDashboardData.filters);

  const [selectedTimeRange, setSelectedTimeRange] = useState({});
  const [tabId, setTabId] = useState(0);
  const [erData, setErData] = useState({});
  const [dealerInfo, setDealerInfo] = useState({});
  const [empType, setEmpType] = useState(0);
  const [assignedJType, setAssignedJType] = useState(0);
  const [dealerData, setDealerData] = useState([]);
  const [selectedDep, setSelectedDep] = useState(0);
  const [selectedRole, setSelectedRole] = useState(0);
  const [allDepIds, setAllDepIds] = useState([]);
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);
  const [employeesRes, setEmployeesRes] = useState({});
  const [empHash, setEmpHash] = useState(null);
  const [selectedJ, setSelectedJ] = useState(null);
  const [department, setDepartment] = useState([]);
  const [learningHistory, setLearningHistory] = useState({});
  // const [userStats, setUserStats] = useState({});
  const [dealerChildrenId, setDealerChildrenId] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpenShareGuide, setIsOpenShareGuide] = useState(false);
  const [isOpenAssignJourney, setIsOpenAssignJourney] = useState(false);
  // const [isOpenGraph, setIsOpenGraph] = useState(false);
  const [dealerAssignRes, setDealerAssignRes] = useState({});
  const [eomAssignRes, setEomAssignRes] = useState({});
  const [tomRes, setTomRes] = useState({});

  const handleClick = () => {
    setDealerId(null);
  };

  useEffect(() => {
    if (appliedFilters.range) {
      setSelectedTimeRange({
        startDate: formatDate(appliedFilters.range.startDate),
        endDate: formatDate(appliedFilters.range.endDate),
      });
    }
  }, []);

  const TABS = [
    { label: `Employees `, index: 0 },
    { label: `Managers`, index: 1 },
    { label: `Assigned Journeys `, index: 2 },
  ];

  useEffect(() => {
    setSelectedRole(0);
  }, [selectedDep]);

  const getEmployees = async (type) => {
    dispatch(showProgress(true));
    const filter = {
      filters: {
        time: {
          ...selectedTimeRange,
          type: timePeriod + 1,
        },
        type,
      },
    };
    if (selectedDep !== 0) {
      filter.filters.departmentId = selectedDep;
    }
    try {
      const res = await service.post(apiEndpoints.PX_EMPLOYESS.replace('ID', dealerId), filter);
      setEmployeesRes(res.employees || {});
      const allEmp = [];

      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in res.employees) {
        const numericKey = Number(key);
        if (!Number.isNaN(numericKey)) {
          allEmp.push(...res.employees[key]);
        }
      }

      setDealerData(allEmp);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getManagers = async () => {
    dispatch(showProgress(true));
    const filter = {
      filters: {
        time: {
          ...selectedTimeRange,
          type: timePeriod + 1,
        },
        type: 'MANAGER_EMPLOYEES',
      },
    };
    if (selectedDep === 0) {
      filter.filters.departmentIds = allDepIds;
    } else {
      filter.filters.departmentIds = [selectedDep];
    }
    try {
      const res = await service.post(apiEndpoints.PX_MANAGERS.replace('ID', dealerId), filter);
      const allManaagers = [];

      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in res.employees) {
        allManaagers.push(...res.employees[key]);
      }
      setDealerData(allManaagers || []);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getTOMJourney = async () => {
    dispatch(showProgress(true));
    const filter = {
      filters: {
        time: {
          ...selectedTimeRange,
          type: timePeriod + 1,
        },
      },
    };

    if (selectedDep === 0) {
      filter.filters.departmentIds = allDepIds;
    } else {
      filter.filters.departmentIds = [selectedDep];
    }

    try {
      const res = await service.post(apiEndpoints.PX_ASSIGNED_JOURNEYS.replace('ID', dealerId), filter);
      const AllToM = [];
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in res.departmentLevel) {
        AllToM.push(...res.departmentLevel[key]);
      }
      setTomRes(res || {});
      const sortedData = sortByEndDate(AllToM);
      setDealerData(sortedData || []);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getDealrAndOEmAssignedJ = async () => {
    dispatch(showProgress(true));
    const filter = {
      dealershipId: dealerId,
      filters: {
        dates: {
          ...selectedTimeRange,
          type: timePeriod + 1,
        },
      },
    };

    const AllDeps = allDepIds;
    if (AllDeps.length > 0 && AllDeps[0] === 0) {
      AllDeps.splice(0, 1);
    }

    if (selectedDep === 0) {
      filter.filters.departmentIds = AllDeps;
    } else {
      filter.filters.departmentIds = [selectedDep];
    }

    try {
      const res = await service.post(apiEndpoints.PX_DEALER_ASSIGNED_JOURNEY, filter);
      if (assignedJType === 1) {
        setDealerAssignRes(res || {});
        const temp = [];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in res.departmentLevelDealer) {
          temp.push(...res.departmentLevelDealer[key]);
        }
        const sortedData = sortByEndDate(temp);
        setDealerData(sortedData || []);
      } else if (assignedJType === 2) {
        setEomAssignRes(res || {});
        const temp = [];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in res.departmentLevelOEM) {
          temp.push(...res.departmentLevelOEM[key]);
        }
        setDealerData(temp);
      }
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const checkTimePeriod = () =>
    timePeriod !== 4 || (timePeriod === 4 && selectedTimeRange.endDate && selectedTimeRange.startDate);

  useEffect(() => {
    if (tabId === 0 && empType === 0 && checkTimePeriod()) {
      getEmployees('ALL_EMPLOYEES');
    }
    if (tabId === 0 && empType === 1 && checkTimePeriod()) {
      getEmployees('INACTIVE_EMPLOYEES');
    }
    if (tabId === 1 && checkTimePeriod()) {
      getManagers();
    }
  }, [tabId, empType, selectedDep, timePeriod, selectedTimeRange]);

  useEffect(() => {
    if (tabId === 2 && assignedJType === 0 && checkTimePeriod()) {
      getTOMJourney();
    }
    if (tabId === 2 && assignedJType === 1 && checkTimePeriod()) {
      getDealrAndOEmAssignedJ();
    }
    if (tabId === 2 && assignedJType === 2 && checkTimePeriod()) {
      getDealrAndOEmAssignedJ();
    }
  }, [tabId, assignedJType, selectedDep, timePeriod, selectedTimeRange]);

  const getData = async () => {
    const pipeline = appliedFilters.salesPipelineStatus?.map((d) => d.id) || [];
    const filter = {
      filters: {
        dealerships: { [dealerId]: dealerChildrenId },
        enabled: true,
        salesPipelineStatus: pipeline,
        time: {
          ...selectedTimeRange,
          type: timePeriod + 1,
        },
        source: appliedFilters.source || [],
        trendRequired: false,
      },
    };
    dispatch(showProgress(true));
    try {
      const res = await service.post(apiEndpoints.PX_REPORT, filter);
      setErData(res || {});
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (checkTimePeriod()) {
      getData();
    }
  }, [timePeriod, selectedTimeRange]);

  const getDealerInfo = async () => {
    try {
      const res = await service.get(apiEndpoints.DEALER_BY_ID.replace('ID', dealerId));
      setDealerInfo(res);
    } catch (error) {
      ErrorToast(error);
    }
  };
  useEffect(() => {
    getDealerInfo();
  }, []);

  const handleTimeRange = (val) => {
    setTimePeriod(val);
    if (val === 4) {
      setIsOpenCalendar(true);
    }
    setSelectedTimeRange({});
  };

  const handleRangeSelection = (range) => {
    setSelectedTimeRange({
      startDate: moment(range.startDate).format('YYYY-MM-DD'),
      endDate: moment(range.endDate).format('YYYY-MM-DD'),
    });
  };

  useEffect(() => {
    if (appliedFilters.range) {
      setSelectedTimeRange({
        startDate: formatDate(appliedFilters.range.startDate),
        endDate: formatDate(appliedFilters.range.endDate),
      });
    }
  }, []);

  useEffect(() => {
    if (selectedRole !== 0 && tabId === 0) {
      const roleEmps = employeesRes[selectedRole];
      setDealerData(roleEmps || []);
    } else if (selectedRole === 0 && tabId === 0) {
      const allEmp = [];
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in employeesRes) {
        const numericKey = Number(key);
        if (!Number.isNaN(numericKey)) {
          allEmp.push(...employeesRes[key]);
        }
      }

      setDealerData(allEmp);
    }

    if (tabId === 2 && assignedJType === 0) {
      if (selectedDep !== 0 && selectedRole !== 0) {
        const temp = tomRes.departmentRoleLevel[selectedRole] || [];
        const sortedData = sortByEndDate(temp);
        setDealerData(sortedData || []);
      } else if (selectedDep !== 0 && selectedRole === 0) {
        const temp = tomRes.departmentLevel[selectedDep] || [];
        const sortedData = sortByEndDate(temp);
        setDealerData(sortedData || []);
      } else if (selectedDep === 0) {
        const temp = [];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in tomRes.departmentLevel) {
          temp.push(...tomRes.departmentLevel[key]);
        }
        const sortedData = sortByEndDate(temp);
        setDealerData(sortedData || []);
      }
    }
    if (tabId === 2 && assignedJType === 1) {
      if (selectedDep !== 0 && selectedRole !== 0) {
        const temp = dealerAssignRes.departmentRoleLevelDealer[selectedRole] || [];
        const sortedData = sortByEndDate(temp);
        setDealerData(sortedData || []);
      } else if (selectedDep !== 0 && selectedRole === 0) {
        const temp = dealerAssignRes.departmentLevelDealer[selectedDep] || [];
        const sortedData = sortByEndDate(temp);
        setDealerData(sortedData || []);
      } else if (selectedDep === 0) {
        const temp = [];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in dealerAssignRes.departmentLevelDealer) {
          temp.push(...dealerAssignRes.departmentLevelDealer[key]);
        }
        const sortedData = sortByEndDate(temp);
        setDealerData(sortedData || []);
      }
    }
    if (tabId === 2 && assignedJType === 2) {
      if (selectedDep !== 0 && selectedRole !== 0) {
        const temp = eomAssignRes.departmentRoleLevelOEM[selectedRole] || [];
        setDealerData(temp || []);
      } else if (selectedDep !== 0 && selectedRole === 0) {
        const temp = eomAssignRes.departmentLevelOEM[selectedDep] || [];
        setDealerData(temp || []);
      } else if (selectedDep === 0) {
        const temp = [];
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in eomAssignRes.departmentLevelOEM) {
          temp.push(...eomAssignRes.departmentLevelOEM[key]);
        }
        setDealerData(temp || []);
      }
    }
  }, [selectedRole]);

  const handleTabClick = (id) => {
    setSelectedDep(0);
    setSelectedRole(0);
    setTabId(id);
  };

  const getLearnerHistory = async () => {
    dispatch(showProgress(true));
    const currentDate = new Date().toISOString().slice(0, 10);

    const payload = {
      hash: empHash,
      presentDate: currentDate,
    };
    try {
      const res = await service.post(apiEndpoints.PX_LEARNING_HISTORY, payload);
      setLearningHistory(res.list || []);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (empHash) {
      getLearnerHistory();
    }
  }, [empHash]);

  // const getUserState = async () => {
  //   dispatch(showProgress(true));
  //   try {
  //     const res = await service.post(apiEndpoints.PX_USER_STATS.replace('ID', selectedJ));
  //     setUserStats(res);
  //   } catch (error) {
  //     ErrorToast(error);
  //   }
  //   dispatch(showProgress(false));
  // };

  // useEffect(() => {
  //   if (selectedJ) {
  //     getUserState();
  //   }
  // }, [selectedJ]);

  useEffect(() => {
    if (dealerId) {
      const dealer = pxDashboardFilters.dealerships?.filter((d) => d.id === dealerId) || [];
      if (dealer.length > 0) {
        const children = dealer[0].children?.map((c) => c.id) || [];
        setDealerChildrenId(children);
      }
    }
  }, [dealerId]);

  const handleClickBtn = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setAssignedJType(0);
    setEmpType(0);
    setSelectedDep(0);
    setSelectedRole(0);
    setDealerData([]);
  }, [tabId]);

  useEffect(() => {
    setSelectedDep(0);
    setSelectedRole(0);
  }, [assignedJType, empType]);

  // Sort journey by endDate
  function sortByEndDate(data) {
    return data.sort((a, b) => {
      const dateA = new Date(a.endDate);
      const dateB = new Date(b.endDate);
      return dateA - dateB;
    });
  }

  return (
    <ReactModal
      isOpen
      shouldCloseOnEsc={false}
      style={{
        overlay: { backgroundColor: 'rgba(0, 0, 0, 0.35)' },
        content: contentStyles,
      }}
    >
      <Grid className={classes.modal}>
        <Grid className={classes.btn}>
          <Button onClick={handleClick}>
            <KeyboardBackspace /> <span style={{ marginLeft: '10px' }}>Back</span>
          </Button>
        </Grid>

        <Grid className={classes.dealershipContainer}>
          <Grid className={classes.dealerInfo}>
            <Grid className={classes.infos}>
              <Typography className={classes.heading}>{dealerInfo.name}</Typography>
              <Typography>
                ID: {dealerId} &nbsp; &nbsp; &nbsp; Date Created: {dealerInfo.createdAt} &nbsp; &nbsp; &nbsp; PX
                Contact:
                {dealerInfo.pxOwnerName}
              </Typography>
            </Grid>
            <Grid className={classes.btnBox}>
              <Button
                variant="contained"
                focusRipple={false}
                disableElevation
                className={classes.shareBtn}
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClickBtn}
              >
                Share & Assign
              </Button>
              <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem
                  className={classes.menuRoot}
                  onClick={() => {
                    setIsOpenShareGuide(true);
                    handleClose();
                  }}
                >
                  Share Guide
                </MenuItem>
                <MenuItem
                  className={classes.menuRoot}
                  onClick={() => {
                    setIsOpenAssignJourney(true);
                    handleClose();
                  }}
                >
                  Assign Journey
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>

          <Grid className={classes.overview}>
            <Grid className={classes.links}>
              <Typography className={classes.title}>Overview</Typography>
              <Button style={{ color: '#622FEE' }} onClick={() => handleOpenInsightPopup(dealerId)}>
                View Insights
              </Button>
              {/* <Button style={{ color: '#622FEE' }} onClick={() => setIsOpenGraph(true)}>
                View Graphs
              </Button> */}
            </Grid>
            <Grid className={classes.btnBox}>
              <FormControl>
                <Select
                  input={<Input disableUnderline className={classes.textfield} />}
                  value={timePeriod}
                  renderValue={(value) =>
                    selectedTimeRange.startDate && selectedTimeRange.endDate
                      ? `${selectedTimeRange.startDate} - ${selectedTimeRange.endDate}`
                      : PERIOD_ARR[value]
                  }
                  displayEmpty
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 48 * 4.5 + 8,
                        width: 250,
                      },
                    },
                  }}
                >
                  {PERIOD_ARR.map((s, key) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <MenuItem value={key} key={key} onClick={() => handleTimeRange(key)}>
                      {s}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid className={classes.cards}>
            <Grid item style={{ backgroundColor: Theme.palette.secondary.main, paddingBottom: '10px', width: '100%' }}>
              <Grid
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'space-between',
                  justifyContent: 'space-between',
                }}
              >
                {erData?.metrics?.map((card) => (
                  <Grid key={card.name} style={{ width: '24%' }}>
                    <PXMetrics
                      title={card.name}
                      value={card.percentage}
                      type={card.type}
                      delta={card.delta}
                      color={card.color}
                      subtext={card.subText}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.table}>
            <TabNativeContent tabValue={tabId} setTabValue={(id) => handleTabClick(id)} tabs={TABS} tabWidth="17%" />
            {tabId === 2 && (
              <Grid className={classes.filterBtn}>
                <Button
                  className={assignedJType === 0 ? classes.activeFilterBtn : classes.deactiveFilterBtn}
                  onClick={() => setAssignedJType(0)}
                >
                  Topic of the Month Journeys
                </Button>
                <Button
                  className={assignedJType === 1 ? classes.activeFilterBtn : classes.deactiveFilterBtn}
                  onClick={() => setAssignedJType(1)}
                >
                  Dealer Assigned Journeys
                </Button>
                <Button
                  className={assignedJType === 2 ? classes.activeFilterBtn : classes.deactiveFilterBtn}
                  onClick={() => setAssignedJType(2)}
                >
                  OEM Assigned Journeys
                </Button>
              </Grid>
            )}
            {tabId === 0 && (
              <Grid className={classes.filterBtn}>
                <Button
                  className={empType === 0 ? classes.activeFilterBtn : classes.deactiveFilterBtn}
                  onClick={() => setEmpType(0)}
                >
                  All Employees
                </Button>
                <Button
                  className={empType === 1 ? classes.activeFilterBtn : classes.deactiveFilterBtn}
                  onClick={() => setEmpType(1)}
                >
                  Inactive Employees
                </Button>
              </Grid>
            )}
            <TableWrapper
              data={dealerData}
              tabId={tabId}
              batchSize={20}
              dealerId={dealerId}
              selectedDep={selectedDep}
              setSelectedDep={setSelectedDep}
              setAllDepIds={setAllDepIds}
              selectedRole={selectedRole}
              setSelectedRole={setSelectedRole}
              selectedTimeRange={selectedTimeRange}
              timePeriod={timePeriod}
              empType={empType}
              Jtype={assignedJType}
              setEmpHash={setEmpHash}
              setSelectedJ={setSelectedJ}
              department={department}
              setDepartment={setDepartment}
            />
          </Grid>
        </Grid>
      </Grid>
      {isOpenCalendar && (
        <CustomDatePopup
          handleRangeSelection={handleRangeSelection}
          setAppliedFilters={setAppliedFilters}
          setIsOpenCalendar={setIsOpenCalendar}
        />
      )}
      {empHash && <LearningHistory empHash={empHash} setEmpHash={setEmpHash} learningHistory={learningHistory} />}
      {selectedJ && <UserStats selectedJ={selectedJ} setSelectedJ={setSelectedJ} />}
      {isOpenShareGuide && (
        <ShareGuidePopup
          isOpen={isOpenShareGuide}
          setIsOpen={setIsOpenShareGuide}
          callFrom="px"
          dealershipId={dealerId}
        />
      )}
      {isOpenAssignJourney && (
        <AssignJourneyPopup
          isOpen={isOpenAssignJourney}
          setIsOpen={setIsOpenAssignJourney}
          callFrom="px"
          dealershipId={dealerId}
        />
      )}
      {/* {isOpenGraph && <PxGraph isOpenGraph={isOpenGraph} setIsOpenGraph={setIsOpenGraph} />} */}
    </ReactModal>
  );
};
